<template>
  <v-app style="background-color: #f8f9fb">
    <v-divider></v-divider>
    <br /><br />

    <v-container style="background-color: #eee" id="uras" fluid tag="section">
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-robot"
            title="URA"
            color="rgb(71 130 180)"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row style="margin-top: 1rem">
                <v-col cols="12" sm="6">
                  <span>Empresa</span>
                  <v-select
                    dense
                    solo-inverted
                    :items="empresasFiltradas"
                    v-model="empresaSelecionada"
                    filled
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                    label="Empresa"
                    @change="carregarTemplates"
                  >
                  </v-select>
                </v-col>

                <v-col cols="12" sm="6">
                  <span>Origem</span>
                  <v-select
                    dense
                    solo-inverted
                    :items="templatesDisponiveis"
                    v-model="origem"
                    item-text="nome"
                    item-value="id"
                    :disabled="!empresaSelecionada || carregandoTemplates"
                    :loading="carregandoTemplates"
                    filled
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                    label="Origem"
                    hint="Estado atual em que o cliente está"
                    persistent-hint
                  >
                    <template v-slot:selection="{ item }">
                      {{ item.nome }}
                    </template>

                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.nome }} ({{
                          item.empresa
                        }})</v-list-item-title>
                        <v-list-item-subtitle>{{
                          truncateText(item.texto, 50)
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12" sm="6">
                  <span>Palavras-Chave</span>
                  <v-combobox
                    dense
                    solo-inverted
                    v-model="palavrasChaves"
                    label="Palavras-Chave"
                    hint="Pressione Enter para adicionar uma palavra-chave"
                    persistent-hint
                    multiple
                    chips
                    filled
                    :rules="[
                      (v) =>
                        (v && v.length > 0) ||
                        'Adicione pelo menos uma palavra-chave',
                    ]"
                  >
                    <template
                      v-slot:selection="{ attrs, item, select, selected }"
                    >
                      <v-chip
                        v-bind="attrs"
                        :input-value="selected"
                        close
                        @click="select"
                        @click:close="removerPalavraChave(item)"
                      >
                        {{ item }}
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-col>

                <v-col cols="12" sm="6">
                  <span>Atalho</span>
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="atalho"
                    label="Atalho"
                    hint="Opcional. Deve começar com #"
                    persistent-hint
                    filled
                    :rules="[
                      (v) =>
                        !v ||
                        String(v).trim().startsWith('#') ||
                        'O atalho deve começar com #',
                    ]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <span>Template de Resposta</span>
                  <v-select
                    dense
                    solo-inverted
                    :items="templatesDisponiveis"
                    v-model="templateResposta"
                    item-text="nome"
                    item-value="id"
                    :disabled="!empresaSelecionada || carregandoTemplates"
                    :loading="carregandoTemplates"
                    filled
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                    label="Template de Resposta"
                    hint="Resposta a ser enviada ao cliente caso identifique alguma das palavras chaves"
                    persistent-hint
                  >
                    <template v-slot:selection="{ item }">
                      {{ item.nome }}
                    </template>
                    
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.nome }} ({{
                          item.empresa
                        }})</v-list-item-title>
                        <v-list-item-subtitle>{{
                          truncateText(item.texto, 50)
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </v-col>
              </v-row>

              <v-card-actions class="d-flex justify-end">
                <v-btn
                  v-if="uraEditandoId"
                  color="grey"
                  @click="cancelarEdicao"
                  class="mr-2"
                >
                  <v-icon left>mdi-close</v-icon> Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="salvando"
                  :disabled="!podeSalvar"
                  @click="salvarUra"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  {{ uraEditandoId ? "Atualizar" : "Salvar" }}
                </v-btn>
              </v-card-actions>
            </v-form>

            <v-data-table
              style="margin-top: 1rem"
              :headers="uras_header"
              :items="listaUras"
              :items-per-page="50"
              items-per-page-text="Linhas por página"
              class="elevation-0"
            >
              <template v-slot:top>
                <v-progress-linear
                  v-if="carregandoUras"
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>

              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td class="linha" style="width: 5%; font-size: 14px">
                    {{ row.item.id }}
                  </td>

                  <td class="linha" style="width: 15%; font-size: 14px">
                    {{ row.item.empresa }}
                  </td>
                  
                  <td class="linha" style="width: 15%; font-size: 14px">
                    {{ row.item.origemNome }}
                  </td>

                  <td class="linha" style="width: 40%; font-size: 14px">
                    <v-chip
                      v-for="(palavra, index) in row.item.palavrasChaves"
                      :key="index"
                      small
                      class="mr-1 mb-1"
                      color="primary"
                      text-color="white"
                    >
                      {{ palavra }}
                    </v-chip>
                  </td>

                  <td class="linha" style="width: 10%; font-size: 14px">
                    {{ row.item.atalho || "-" }}
                  </td>

                  <td class="linha" style="width: 15%; font-size: 14px">
                    {{ row.item.templateRespostaNome }}
                  </td>

                  <td class="linha" style="width: 10%; font-size: 14px">
                    <v-btn
                      @click="editarUra(row.item)"
                      fab
                      small
                      color="primary"
                      class="mr-2"
                      title="Editar URA"
                    >
                      <v-icon dark> mdi-pencil </v-icon>
                    </v-btn>
                    <v-btn
                      @click="deletarUra(row.item.id)"
                      fab
                      small
                      color="error"
                      title="Excluir URA"
                    >
                      <v-icon dark> mdi-delete </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Wazzup from "@/services/wazzup";

export default {
  name: "Uras",
  mounted() {
    this.carregarListaUras();
  },
  data() {
    return {
      rules: {
        required: (v) => !!v || "Obrigatório.",
      },
      valid: true,

      empresas: [
        "A FLOR DO CAFÉ",
        "CEMITERIO PREVIDA",
        "CEMITERIO PREVIDA SÃO MIGUEL",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "PREVIDA",
      ],
      empresaSelecionada: "",

      origem: "",
      templateResposta: null,
      palavrasChaves: [],
      atalho: "",
      uraEditandoId: null,

      salvando: false,

      templatesDisponiveis: [],
      carregandoTemplates: false,

      listaUras: [],
      carregandoUras: false,
      uras_header: [
        { text: "ID", value: "id" },
        { text: "Empresa", value: "empresa" },
        { text: "Origem", value: "origemNome" },
        { text: "Palavras-Chave", value: "palavrasChaves" },
        { text: "Atalho", value: "atalho" },
        { text: "Template", value: "templateRespostaNome" },
        { text: "Ações", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    empresasFiltradas() {
      // Filtra as empresas com base nas permissões do usuário
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },
    podeSalvar() {
      return (
        this.origem &&
        this.empresaSelecionada &&
        this.templateResposta &&
        this.palavrasChaves.length > 0 &&
        !this.salvando
      );
    },
  },
  methods: {
    hasPermission(empresa) {
      const user = JSON.parse(sessionStorage.getItem("user"));
      if (!user || !user.roles) return false;

      if (user.roles.includes("ROLE_ADMIN")) {
        return true;
      }

      const requiredRoles = empresa
        .split(" ")
        .map((name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_"));

      return requiredRoles.some((role) => user.roles.includes(role));
    },

    truncateText(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength
        ? text.substring(0, maxLength) + "..."
        : text;
    },

    removerPalavraChave(item) {
      this.palavrasChaves.splice(this.palavrasChaves.indexOf(item), 1);
    },

    carregarTemplates() {
      if (!this.empresaSelecionada) {
        this.templatesDisponiveis = [];
        return;
      }

      this.carregandoTemplates = true;
      Wazzup.listarTemplates()
        .then((resp) => {
          if (resp && resp.status === 200 && resp.data) {
            // A resposta pode vir como array direto ou dentro de um objeto
            if (Array.isArray(resp.data)) {
              this.templatesDisponiveis = resp.data;
            } else if (resp.data.data && Array.isArray(resp.data.data)) {
              this.templatesDisponiveis = resp.data.data;
            } else {
              this.templatesDisponiveis = [];
            }

            // Filtrar apenas templates URA
            this.templatesDisponiveis = this.templatesDisponiveis
              .filter((t) => t.ura === true)
              .sort((a, b) => {
                const empresaA = (a.empresa || '').toUpperCase();
                const empresaB = (b.empresa || '').toUpperCase();
                return empresaA.localeCompare(empresaB);
              });
          } else {
            this.templatesDisponiveis = [];
          }
        })
        .catch((e) => {
          console.error("Erro ao carregar templates:", e);
          this.templatesDisponiveis = [];
        })
        .finally(() => {
          this.carregandoTemplates = false;
        });
    },

    salvarUra() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (!this.podeSalvar) {
        return;
      }

      this.salvando = true;

      const payload = {
        id: this.uraEditandoId,
        origemId: this.origem,
        templateRespostaId: this.templateResposta,
        palavrasChaves: this.palavrasChaves,
        empresa: this.empresaSelecionada,
        atalho: this.atalho ? this.atalho.trim() : null,
      };

      const method = this.uraEditandoId
        ? Wazzup.atualizarUra(this.uraEditandoId, payload)
        : Wazzup.criarUra(payload);

      method
        .then(() => {
          const mensagem = this.uraEditandoId
            ? "URA atualizada com sucesso!"
            : "URA salva com sucesso!";
          this.$toast &&
            this.$toast.success(mensagem, {
              timeout: 3000,
            });
          // Limpa o formulário
          this.limparFormulario();
          // Recarrega a lista de URAs
          this.carregarListaUras();
        })
        .catch((e) => {
          // Exibe o erro retornado pelo backend
          const msg =
            (e.response && e.response.data && e.response.data.message) ||
            e.message ||
            "Erro ao salvar URA.";
          if (this.$toast) {
            this.$toast.error(msg, { timeout: 5000 });
          } else {
            alert(msg);
          }
        })
        .finally(() => {
          this.salvando = false;
        });
    },

    editarUra(ura) {
      // Preenche o formulário com os dados da URA
      this.uraEditandoId = ura.id;
      this.empresaSelecionada = ura.empresa;

      // Carregar templates para a empresa selecionada
      this.carregarTemplates();

      // Definir o template após carregar a lista
      this.$nextTick(() => {
        this.templateResposta = ura.templateRespostaId;
        this.origem = ura.origemId;
      });

      this.palavrasChaves = ura.palavrasChaves || [];
      this.atalho = ura.atalho || "";

      // Scroll suave até o formulário
      this.$nextTick(() => {
        const formElement = document.getElementById("uras");
        if (formElement) {
          formElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },

    cancelarEdicao() {
      this.limparFormulario();
    },

    limparFormulario() {
      this.uraEditandoId = null;
      this.origem = "";
      this.templateResposta = null;
      this.palavrasChaves = [];
      this.atalho = "";
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    carregarListaUras() {
      this.carregandoUras = true;
      Wazzup.listarUras()
        .then((resp) => {
          if (resp && resp.status === 200 && resp.data) {
            // A resposta pode vir como array direto ou dentro de um objeto
            if (Array.isArray(resp.data)) {
              this.listaUras = resp.data;
            } else if (resp.data.data && Array.isArray(resp.data.data)) {
              this.listaUras = resp.data.data;
            } else {
              this.listaUras = [];
            }

            // Carregar todos os templates para exibir os nomes na tabela
            this.carregarTodosTemplates();
          } else {
            this.listaUras = [];
          }
        })
        .catch((e) => {
          console.error("Erro ao carregar lista de URAs:", e);
          this.listaUras = [];
        })
        .finally(() => {
          this.carregandoUras = false;
        });
    },

    carregarTodosTemplates() {
      // Carregar todos os templates para poder exibir os nomes na tabela
      Wazzup.listarTemplates()
        .then((resp) => {
          if (resp && resp.status === 200 && resp.data) {
            if (Array.isArray(resp.data)) {
              this.templatesDisponiveis = resp.data;
            } else if (resp.data.data && Array.isArray(resp.data.data)) {
              this.templatesDisponiveis = resp.data.data;
            }
          }
        })
        .catch((e) => {
          console.error("Erro ao carregar todos os templates:", e);
        });
    },

    deletarUra(id) {
      if (!confirm("Deseja realmente excluir esta URA?")) {
        return;
      }

      Wazzup.deletarUra(id)
        .then(() => {
          this.$toast && this.$toast.success("URA excluída com sucesso!");
          this.carregarListaUras();
        })
        .catch((e) => {
          const msg =
            e.response?.data?.message || e.message || "Erro ao excluir URA.";
          if (this.$toast) {
            this.$toast.error(msg, { timeout: 5000 });
          } else {
            alert(msg);
          }
        });
    },
  },
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.justify-center {
  justify-content: center;
}

.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important;
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
</style>
